import SigliveServiceV1 from 'Service/sigliveServiceV1';

const deleteRuleset = async ({ id }) => {
  const { data } = await SigliveServiceV1({ method: 'DELETE', url: `/schedule-ruleset/${id}` });

  return data;
};

export default deleteRuleset;
